import { render, staticRenderFns } from "./center_13.vue?vue&type=template&id=4a484881&scoped=true&"
import script from "./center_13.vue?vue&type=script&lang=js&"
export * from "./center_13.vue?vue&type=script&lang=js&"
import style0 from "./center_13.vue?vue&type=style&index=0&id=4a484881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a484881",
  null
  
)

export default component.exports